<script setup lang="ts">
import type { ProgressRootProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { ProgressIndicator, ProgressRoot } from 'reka-ui';

const props = withDefaults(
  defineProps<ProgressRootProps & { class?: HTMLAttributes['class']; indicatorClass?: HTMLAttributes['class'] }>(),
  {
    modelValue: 0,
    indicatorClass: 'bg-brand-primary-600',
  },
);

const delegatedProps = reactiveOmit(props, 'class', 'indicatorClass');
</script>

<template>
  <ProgressRoot
    v-bind="delegatedProps"
    :class="cn('relative h-2 w-full overflow-hidden rounded-full bg-brand-primary-100', props.class)"
  >
    <ProgressIndicator
      :class="cn('h-full w-full flex-1 rounded-full transition-all duration-700', props.indicatorClass)"
      :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
    />
  </ProgressRoot>
</template>
